<template>

  <InfoPraticheDossier />
 
</template>

<script>
import InfoPraticheDossier from '../components/pratiche/InfoPraticheDossier.vue'

export default {
  components: {
    InfoPraticheDossier
  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>

